export const getBankLogo = logoName => {
  let logo;
  try {
    let logoImg = require(`./${logoName}`);
    logo = logoImg;
  } catch (e) {}
  return logo;
};

/* const importAll = require =>
  require.keys().reduce((acc, next) => {
    acc[next.replace("./", "")] = require(next);
    return acc;
  }, {});

export const bankLogos = importAll(
  require.context("./", false, /\.(png|jpe?g|svg)$/)
);*/
